import { useEffect, useState } from "react";
import api from "../../lib/api";
import SEO from "../../components/SEO";
import { inputCls } from "./AFields";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get(`/admin/audit-logs?q=${encodeURIComponent(q)}`).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div data-testid="admin-audit">
      <SEO title="Audit Logs" />
      <h1 className="font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl">Audit Logs</h1>
      <div className="mt-6 flex gap-3">
        <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search actor / action / entity…" className={`${inputCls} !w-80`} data-testid="audit-search" />
        <button onClick={load} className="rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-navy" data-testid="audit-search-btn">Search</button>
      </div>
      <div className="mt-6 overflow-x-auto rounded-lg border border-gray-200 bg-white">
        <table className="w-full min-w-[720px] text-left text-sm">
          <thead className="border-b border-gray-200 bg-navy-50/50 text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3">Time</th><th className="px-4 py-3">Actor</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Entity</th><th className="px-4 py-3">Detail</th></tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-b border-gray-100 last:border-0">
                <td className="whitespace-nowrap px-4 py-2.5 text-xs text-slate-500">{String(a.at).slice(0, 19).replace("T", " ")}</td>
                <td className="px-4 py-2.5 font-semibold text-navy">{a.actor}</td>
                <td className="px-4 py-2.5"><span className="rounded-full bg-navy-50 px-2.5 py-0.5 text-[11px] font-bold uppercase text-navy">{a.action}</span></td>
                <td className="px-4 py-2.5">{a.entity}</td>
                <td className="max-w-[240px] truncate px-4 py-2.5 text-slate-500">{a.detail || "—"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-400">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
